export default function definitionTooltip(eggDefinitions) {
  // Flat merged lookup (types take priority over packaging for shared keys like CTN)
  var lookup = {};
  var categoryOrder = ['other', 'deliveries', 'packaging', 'classes', 'colors', 'types'];
  categoryOrder.forEach(function(cat) {
    if (!eggDefinitions[cat]) return;
    Object.keys(eggDefinitions[cat]).forEach(function(key) {
      lookup[key.trim()] = eggDefinitions[cat][key];
    });
  });
  return function(input, category) {
    if (!input) return '';
    var trimmed = String(input).trim();
    if (category && eggDefinitions[category]) {
      return eggDefinitions[category][trimmed] || '';
    }
    return lookup[trimmed] || '';
  };
}
